import React, { FocusEvent } from 'react';

import AcSelect from 'components/AcSelect/AcSelect';
import { AcSelectItem } from 'components/AcSelect/AcSelect.types';

interface IQuantityFormatSelectProps {
  header: string;
  name: string;
  value: string;
  items: AcSelectItem[];
  isFetching: boolean;
  error: boolean;
  onFieldChange: (fieldPath: string, rawValue: string) => void;
  onBlur: (event: FocusEvent<HTMLElement>) => void;
}

export const QuantityFormatSelect = ({
  header,
  name,
  value,
  items,
  isFetching,
  error,
  onFieldChange,
  onBlur
}: IQuantityFormatSelectProps): React.ReactElement => (
  <AcSelect
    loading={isFetching}
    header={header}
    name={name}
    value={value}
    items={items}
    onChange={(event) => onFieldChange(name, String(event.target.value))}
    onBlur={onBlur}
    error={error}
  />
);
